// 引用api文件
import api from '../index';
/**
 * @author yangluyao
 * @date 2020-02-25
 * @Description: 任务模块
 */
// 获取已完成任务列表  --对应文书打印
export function getTaskList(data, success, failure, menuId) { return api.postFormData('hzf-admin/sys/inspectBaseInfo/complete_page_list', data, success, failure, menuId); }
// 获取pdf
export function getPDFById(data, success, failure, menuId) { return api.post('hzf-admin/sys/inspectBaseInfo/getPdfByInspectBaseId', data, success, failure, menuId); }
// 获取已完成任务的产品信息
export function getProductInfoAboutCompletetask(data, success, failure, menuId) { return api.postFormData('hzf-admin/sys/complete/inspectBaseInfo/getCompleteCheckProductInfo', data, success, failure, menuId); }
// 获取已完成任务的检查记录详情
export function getcheckInfoAboutCompletetask(data, success, failure, menuId) { return api.post('hzf-admin/sys/complete/inspectBaseInfo/detail', data, success, failure, menuId); }

/**
 * @author yangluyao
 * @date 2020-02-25
 * @Description: 任务，地图与列表模式+-+---
*/
// 获取经纬度
export function getLatiyudeAndLongtitude(data, success, failure, menuId) { return api.post('hzf-admin/sys/inspectBaseInfo/list_two', data, success, failure, menuId); }
// 获取地图细节
export function getMapDetail(data, success, failure, menuId) { return api.post('hzf-admin/sys/inspectBaseInfo/detail_map', data, success, failure, menuId); }
// 双随机 - 任务修改
export function updateTaskDoubleRandom(data, success, failure, menuId) { return api.postFormData('double-random/sys/inspectTesk/updateTask', data, success, failure, menuId); }
// 双随机 - 任务新建
export function addTaskDoubleRandom(data, success, failure, menuId) { return api.postFormData('double-random/sys/inspectTesk/saveOneTesk', data, success, failure, menuId); }
// 双随机 - 获取任务
export function getTakInfoDoubleRandom(data, success, failure, menuId) { return api.postFormData('double-random/sys/inspectTesk/getTaskInfosByTimeAndStatus', data, success, failure, menuId); }
// 双随机 - 任务删除
export function delTakDoubleRandom(data, success, failure, menuId) { return api.postFormData('double-random/sys/inspectTesk/deleteTask', data, success, failure, menuId); }
// 双随机 - 任务删除
export function getTaskListDoubleRandom(data, success, failure, menuId) { return api.postFormData('double-random/sys/inspectTesk/getTaskListbysearch', data, success, failure, menuId); }
/*
// 双随机 - 任务删除
export function getTaskCalenderDoubleRandom(data, success, failure, menuId) { return api.postFormData('double-random/sys/inspectTesk/getTaskTimesAndDays', data, success, failure, menuId); }
*/
